import React, { useCallback, useEffect, useState } from 'react';
import { Dialog, DialogTitle, IconButton, Box, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getBaseUrl } from 'utils/validators/HelperFunctions';

const PDFViewerModal = ({
  pdfUrl,
  setMenuModal,
  menuModal,
}: {
  pdfUrl: string;
  setMenuModal: any;
  menuModal: boolean;
}) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleOpen = useCallback(async () => {
    setMenuModal(true);
    setLoading(true);
    try {
      const response = await fetch(getBaseUrl() + pdfUrl);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setBlobUrl(url);
    } catch (err) {
      console.error('Failed to load PDF:', err);
    } finally {
      setLoading(false);
    }
  }, [pdfUrl, setMenuModal]);
  useEffect(() => {
    if (menuModal) {
      handleOpen();
    }
  }, [menuModal, handleOpen]);

  const handleClose = () => {
    setMenuModal(false);
    if (blobUrl) {
      URL.revokeObjectURL(blobUrl);
      setBlobUrl(null);
    }
  };

  return (
    <Dialog open={menuModal} onClose={handleClose} fullWidth maxWidth="lg">
      <DialogTitle>
        PDF Preview
        <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Box sx={{ height: '80vh', position: 'relative' }}>
        {loading && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}>
            <CircularProgress />
          </Box>
        )}
        {blobUrl && !loading && (
          <iframe src={blobUrl} title="PDF Preview" width="100%" height="100%" style={{ border: 'none' }} />
        )}
      </Box>
    </Dialog>
  );
};

export default PDFViewerModal;
